import { Paper, Typography, Box, Divider, Stack, Button } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import { useEffect, useState } from "react";
import { getCommunityStats } from "../api/stats";

export default function CommunityInfo({ onCreate }: { onCreate?: () => void }) {
    const [memberCount, setMemberCount] = useState<number>(0);

    useEffect(() => {
        getCommunityStats().then(s => setMemberCount(s.member_count)).catch(console.error);
    }, []);
    
  return (
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
            <InfoOutlinedIcon fontSize="small" color="action" />
            <Typography variant="subtitle2" fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                About Community
            </Typography>
        </Stack>
        
        <Box sx={{ mb: 3 }}>
            <Typography variant="h5" fontWeight={800} gutterBottom>
                Threadly
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph sx={{ lineHeight: 1.6 }}>
                Welcome to Threadly! The place to discuss everything from tech to lifestyle. 
                Share your thoughts, ask questions, and connect with others.
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2 }}>
                <CakeOutlinedIcon fontSize="small" color="action" />
                <Typography variant="caption" color="text.secondary" fontWeight={500}>
                    Created Jan 10, 2026
                </Typography>
            </Stack>

            <Stack direction="row" spacing={3} sx={{ mt: 3 }}>
                <Box>
                    <Typography variant="h6" fontWeight={700}>{memberCount}</Typography>
                    <Typography variant="caption" color="text.secondary">Members</Typography>
                </Box>
            </Stack>
        </Box>

        {onCreate && (
            <>
                <Divider sx={{ my: 2 }} />
                <Button variant="contained" fullWidth onClick={onCreate} sx={{ borderRadius: 2 }}>
                    Create Post
                </Button>
            </>
        )}

        <Divider sx={{ my: 2 }} />

        <Box>
            <Typography variant="subtitle2" fontWeight={700} gutterBottom sx={{ mb: 1 }}>
                Forum Rules
            </Typography>
            <Stack spacing={1.5}>
                <Typography variant="body2" color="text.secondary">1. Be respectful to others.</Typography>
                <Typography variant="body2" color="text.secondary">2. No spam or self-promotion.</Typography>
                <Typography variant="body2" color="text.secondary">3. Stay on topic.</Typography>
            </Stack>
        </Box>
    </Paper>
  );
}
